import React, { useState, useEffect } from 'react';
import { Code, Layers, Eye, Heart, Star, ArrowRight } from 'lucide-react';
import styles from './WebDeveloperContent.module.css';

const WebDeveloperContent = ({ onModeChange }) => {
  const [activeCard, setActiveCard] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 20;
      const y = (e.clientY / window.innerHeight - 0.5) * 20;
      setMousePosition({ x, y });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const handleViewPortfolio = () => {
    if (onModeChange) {
      onModeChange('web');
    }
  };



  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* Animated Background */}
        <div className={styles.bgElements}>
          <div 
            className={styles.blob1} 
            style={{ transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)` }}
          />
          <div 
            className={styles.blob2} 
            style={{ transform: `translate(${-mousePosition.x}px, ${-mousePosition.y}px)` }}
          />
          <div className={styles.blob3} />
        </div>

        {/* Floating Shapes */}
        <div className={styles.floatingShapes}>
          {[...Array(6)].map((_, i) => (
            <div key={i} className={`${styles.shape} ${styles[`shape${i + 1}`]}`} />
          ))}
        </div>

        <div className={styles.content}>
          {/* Header */}
          <div className={styles.header}>
            <div className={styles.badge}>
              <Code size={18} />
              <span>Full Stack Developer</span>
            </div>
            <h2 className={styles.title}>
              I'm Also Working as a <span className={styles.highlight}>Web Developer</span>
            </h2>
            <p className={styles.subtitle}>
              Building modern, responsive websites and web applications with cutting-edge technologies and innovative solutions.
            </p>
          </div>

          
          {/* Stats Section */}
          <div className={styles.stats}>
            <div className={styles.statItem}>
              <div className={styles.statIcon}>
                <Layers size={24} />
              </div>
              <div className={styles.statNumber}>50+</div>
              <div className={styles.statLabel}>Web Projects</div>
            </div>
            <div className={styles.statItem}>
              <div className={styles.statIcon}>
                <Heart size={24} />
              </div>
              <div className={styles.statNumber}>100%</div>
              <div className={styles.statLabel}>Client Satisfaction</div>
            </div>
            <div className={styles.statItem}>
              <div className={styles.statIcon}>
                <Star size={24} />
              </div>
              <div className={styles.statNumber}>5+</div>
              <div className={styles.statLabel}>Years Experience</div>
            </div>
            <div className={styles.statItem}>
              <div className={styles.statIcon}>
                <Eye size={24} />
              </div>
              <div className={styles.statNumber}>100K+</div>
              <div className={styles.statLabel}>Code Lines</div>
            </div>
          </div>

          {/* CTA Button */}
          <div className={styles.cta}>
            <button className={styles.ctaButton} onClick={handleViewPortfolio}>
              <Code size={20} />
              <span>View My Web Portfolio</span>
              <ArrowRight size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebDeveloperContent;